import type { RouteRecordRaw } from 'vue-router';

export const authRoutes: RouteRecordRaw[] = [
  {
    path: 'login',
    name: 'auth.login',
    component: () => import('./pages/LoginPage.vue'),
    meta: { title: 'Sign in' },
  },
  {
    path: 'forgot-password',
    name: 'auth.forgot-password',
    component: () => import('./pages/ForgotPasswordPage.vue'),
    meta: { title: 'Forgot password' },
  },
  {
    path: 'reset-password',
    name: 'auth.reset-password',
    component: () => import('./pages/ResetPasswordPage.vue'),
    meta: { title: 'Reset password' },
  },
  {
    path: 'impersonate',
    name: 'auth.impersonate',
    component: () => import('./pages/ImpersonatePage.vue'),
    meta: { title: 'Signing in' },
  },
];
